var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.svgClass,style:(_vm.svgStyle),attrs:{"width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox,"xmlns":"http://www.w3.org/2000/svg"}},[(_vm.icon)?[_c(_vm.getIconComponent(_vm.icon),{tag:"component",attrs:{"fill":_vm.fill,"stroke":_vm.stroke,"stroke-width":_vm.strokeWidth}})]:_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }